(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-section]').forEach(function (root) {
      var json = root.querySelector('[data-product-json]');
      if (!json) return;
      var data = JSON.parse(json.textContent);
      var fieldsets = root.querySelectorAll('.lx-option');
      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-product-price]');
      var compareEl = root.querySelector('[data-compare-price]');
      var saveEl = root.querySelector('[data-save-badge]');
      var addBtn = root.querySelector('[data-add-button]');
      var mainImg = root.querySelector('[data-main-image]');
      var thumbs = root.querySelectorAll('[data-thumb]');

      function selected() {
        return Array.prototype.map.call(fieldsets, function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function findVariant(opts) {
        return data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      var mockup = null; // set up below once the preview helpers exist
      function showMedia(id) {
        var t = root.querySelector('[data-thumb][data-media-id="' + id + '"]');
        if (!t || !mainImg) return;
        mainImg.src = t.dataset.src;
        mainImg.srcset = t.dataset.srcset;
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      }
      // Each card shows the price and availability of its combination with the other current choices
      function refreshCards(opts) {
        fieldsets.forEach(function (fs, i) {
          fs.querySelectorAll('[data-option-value]').forEach(function (input) {
            var test = opts.slice();
            test[i] = input.value;
            var v = findVariant(test);
            var label = input.closest('.lx-choice');
            label.classList.toggle('is-unavailable', !v || !v.available);
            var p = label.querySelector('[data-card-price]');
            if (p) p.textContent = v ? v.price : '';
          });
        });
      }
      function update() {
        var opts = selected();
        var v = findVariant(opts);
        refreshCards(opts);
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.labelUnavailable; }
          return;
        }
        if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        if (priceEl) { priceEl.textContent = v.price; priceEl.classList.toggle('is-sale', !!v.compare); }
        if (compareEl) { compareEl.hidden = !v.compare; compareEl.textContent = v.compare || ''; }
        if (saveEl) { saveEl.hidden = !v.save; saveEl.textContent = v.save ? 'Save ' + v.save : ''; }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldOut;
        }
        if (mockup && mockup.photo) { mockup.render(); mockup.show(); } else if (v.media) { showMedia(v.media); }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      root.querySelectorAll('[data-option-value]').forEach(function (input) {
        input.addEventListener('change', update);
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { if (mockup) mockup.hide(); showMedia(t.dataset.mediaId); });
      });
      refreshCards(selected());

      // ---- Crystal mockup preview (drag to position, zoom, size-aware) ----
      var mockEl = root.querySelector('[data-mockup]');
      if (mockEl) {
        var canvas = mockEl.querySelector('[data-mockup-canvas]');
        var ctx = canvas.getContext('2d');
        var msg = mockEl.querySelector('[data-mockup-msg]');
        var sizePill = mockEl.querySelector('[data-mockup-size]');
        var controls = root.querySelector('[data-mockup-controls]');
        var zoomInput = root.querySelector('[data-mockup-zoom]');
        var resetBtn = root.querySelector('[data-mockup-reset]');
        var seeBtn = root.querySelector('[data-see-preview]');
        var framingInput = root.querySelector('[data-framing-input]');
        var previewFile = root.querySelector('[data-preview-file]');
        var thumbBar = root.querySelector('.lx-thumbs');
        var pThumb = null;

        // Which option is the shape, and which is the size
        var shapeIndex = -1, sizeIndex = -1;
        fieldsets.forEach(function (fs, i) {
          if (fs.querySelector('.lx-choices.is-shape')) { if (shapeIndex < 0) shapeIndex = i; }
          else { sizeIndex = i; }
        });

        // Size dimensions from the section setting. Accepts lines like
        //   Rectangle-Portrait (Mini): 1.57"L x 1.57"W x 2.36"H   (L = width, W = depth, H = height)
        //   Heart / Large: 4.8 x 4.21 x 2.51 in                   (width x height x depth)
        //   Large: 3.1 x 4.7 x 2 in                               (applies to every shape)
        function norm(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
        var dimList = [];
        (mockEl.getAttribute('data-dimensions') || '').split(/\n/).forEach(function (line) {
          var k = line.indexOf(':'); if (k < 1) return;
          var key = line.slice(0, k).trim(), txt = line.slice(k + 1).trim();
          var shape = '', size = key, m = key.match(/^(.*?)\s*\((.+)\)\s*$/);
          if (m) { shape = m[1]; size = m[2]; }
          else if (/[\/+]/.test(key)) { var parts = key.split(/[\/+]/); shape = parts[0]; size = parts.slice(1).join(' '); }
          var nums = [], re = /(\d+(?:\.\d+)?)\s*(?:["”″']+|inch(?:es)?\b|in\b|cm\b|mm\b)?\s*([LWHD])?\b/gi, t;
          while ((t = re.exec(txt))) nums.push({ v: parseFloat(t[1]), l: (t[2] || '').toUpperCase() });
          if (nums.length < 2) return;
          var by = {}; nums.forEach(function (n) { if (n.l) by[n.l] = n.v; });
          var d;
          if (by.L != null && by.H != null) d = { w: by.L, h: by.H, d: by.W != null ? by.W : by.D };
          else if (by.W != null && by.H != null) d = { w: by.W, h: by.H, d: by.D };
          else d = { w: nums[0].v, h: nums[1].v, d: nums[2] ? nums[2].v : null };
          d.unit = /cm\b/i.test(txt) ? 'cm' : /mm\b/i.test(txt) ? 'mm' : 'in';
          d.text = txt.replace(/""+/g, '"');
          dimList.push({ shape: norm(shape), size: norm(size), d: d });
        });
        function lookup(shape, size) {
          var sh = norm(shape), sz = norm(size), best = null, bestRank = 0;
          dimList.forEach(function (e) {
            if (e.size !== sz) return;
            var rank = 0;
            if (!e.shape) rank = 1;                                                   // size-only line
            else if (e.shape === sh) rank = 3;                                        // exact shape
            else if (sh && (sh.indexOf(e.shape) > -1 || e.shape.indexOf(sh) > -1)) rank = 2; // e.g. Heart vs Heart Shape
            if (rank > bestRank || (rank === bestRank && rank === 2 && e.shape.length < best.shape.length)) { best = e; bestRank = rank; }
          });
          return best ? best.d : null;
        }
        // Scale against this product's own sizes only
        var dimMax = 0;
        (function () {
          var shapes = shapeIndex > -1 ? Array.prototype.map.call(fieldsets[shapeIndex].querySelectorAll('[data-option-value]'), function (i) { return i.value; }) : [''];
          var sizes = sizeIndex > -1 ? Array.prototype.map.call(fieldsets[sizeIndex].querySelectorAll('[data-option-value]'), function (i) { return i.value; }) : [];
          shapes.forEach(function (sh) { sizes.forEach(function (sz) { var d = lookup(sh, sz); if (d) dimMax = Math.max(dimMax, d.w, d.h); }); });
        })();
        function currentDims() {
          if (!dimMax) return null;
          var sel = selected();
          return lookup(shapeIndex > -1 ? sel[shapeIndex] : '', sizeIndex > -1 ? sel[sizeIndex] : '');
        }
        function shapeName() {
          if (shapeIndex < 0) return (root.querySelector('h1') || {}).textContent || '';
          return selected()[shapeIndex] || '';
        }

        // Crystal outline paths inside box (x, y, w, h)
        function tracePath(c, kind, x, y, w, h) {
          c.beginPath();
          var r = Math.min(w, h);
          if (kind === 'gemheart') {
            [[.5,.2],[.68,.02],[.88,.04],[1,.22],[.97,.45],[.5,1],[.03,.45],[0,.22],[.12,.04],[.32,.02]].forEach(function (p, i) { c[i ? 'lineTo' : 'moveTo'](x + p[0] * w, y + p[1] * h); });
          } else if (kind === 'heart') {
            c.moveTo(x + w / 2, y + h);
            c.bezierCurveTo(x - w * .12, y + h * .55, x - w * .02, y - h * .12, x + w / 2, y + h * .2);
            c.bezierCurveTo(x + w * 1.02, y - h * .12, x + w * 1.12, y + h * .55, x + w / 2, y + h);
          } else if (kind === 'circle') {
            c.ellipse(x + w / 2, y + h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
          } else if (kind === 'diamond') {
            [[.22,0],[.78,0],[1,.3],[.5,1],[0,.3]].forEach(function (p, i) { c[i ? 'lineTo' : 'moveTo'](x + p[0] * w, y + p[1] * h); });
          } else if (kind === 'gemrect' || kind === 'octagon') {
            var k = kind === 'octagon' ? r * .29 : r * .14;
            c.moveTo(x + k, y); c.lineTo(x + w - k, y); c.lineTo(x + w, y + k); c.lineTo(x + w, y + h - k);
            c.lineTo(x + w - k, y + h); c.lineTo(x + k, y + h); c.lineTo(x, y + h - k); c.lineTo(x, y + k);
          } else {
            var rr = r * .025;
            c.moveTo(x + rr, y); c.arcTo(x + w, y, x + w, y + h, rr); c.arcTo(x + w, y + h, x, y + h, rr);
            c.arcTo(x, y + h, x, y, rr); c.arcTo(x, y, x + w, y, rr);
          }
          c.closePath();
        }
        // Box size (fractions of the canvas) for the current shape + size
        function layout(img) {
          var n = shapeName().toLowerCase(), kind, bw, bh, fixedAspect = false;
          if (n.indexOf('heart') > -1) { kind = n.indexOf('gem') > -1 ? 'gemheart' : 'heart'; bw = .72; bh = .65; fixedAspect = true; }
          else if (n.indexOf('circle') > -1 || n.indexOf('round') > -1 || n.indexOf('sphere') > -1) { kind = 'circle'; bw = bh = .66; fixedAspect = true; }
          else if (n.indexOf('diamond') > -1) { kind = 'diamond'; bw = .72; bh = .65; fixedAspect = true; }
          else if (n.indexOf('octagon') > -1) { kind = 'octagon'; bw = bh = .66; fixedAspect = true; }
          else {
            kind = n.indexOf('gem') > -1 ? 'gemrect' : 'rect';
            if (n.indexOf('square') > -1 || n.indexOf('cube') > -1) { bw = bh = .62; fixedAspect = true; }
            else {
              var cd = currentDims();
              var landscape = n.indexOf('landscape') > -1 || n.indexOf('horizontal') > -1 ||
                (n.indexOf('portrait') < 0 && n.indexOf('vertical') < 0 &&
                  (cd ? cd.w > cd.h * 1.05 : (img && img.width > img.height * 1.05)));
              if (landscape) { bw = .76; bh = .53; } else { bw = .5; bh = .67; }
            }
          }
          var d = currentDims(), scale = 1, depth = .045;
          if (d) {
            var big = Math.max(d.w, d.h), small = Math.min(d.w, d.h);
            if (!fixedAspect && big > 0) {
              // Use the real proportions, keeping the orientation chosen above
              var maxSide = Math.max(bw, bh);
              if (bw >= bh) { bw = maxSide; bh = maxSide * small / big; } else { bh = maxSide; bw = maxSide * small / big; }
            }
            scale = Math.max(.45, big / dimMax);
            if (d.d) depth = Math.min(.09, Math.max(.025, .045 * (d.d / small) * 1.4));
          }
          return { kind: kind, w: bw * scale, h: bh * scale, depth: depth * scale, dims: d };
        }

        // Framing state: zoom >= 1 (cover), pan as fractions of the free space (-1..1)
        var frame = { zoom: 1, px: 0, py: 0 };
        var noise = null, noiseW = 0, noiseH = 0, engCanvas = document.createElement('canvas');
        function engrave(img, w, h, kind) {
          if (noiseW !== w || noiseH !== h) {
            noise = new Float32Array(w * h);
            for (var n = 0; n < noise.length; n++) noise[n] = 0.62 + Math.random() * 0.38;
            noiseW = w; noiseH = h;
          }
          engCanvas.width = w; engCanvas.height = h;
          var o = engCanvas.getContext('2d');
          var s = Math.max(w / img.width, h / img.height) * frame.zoom;
          var dw = img.width * s, dh = img.height * s;
          var ox = (w - dw) / 2 + frame.px * (dw - w) / 2;
          var oy = (h - dh) / 2 + frame.py * (dh - h) / 2;
          o.drawImage(img, ox, oy, dw, dh);
          var data = o.getImageData(0, 0, w, h), px = data.data, cx = w / 2, cy = h / 2;
          var round = kind === 'circle' || kind === 'heart' || kind === 'gemheart';
          for (var yy = 0; yy < h; yy++) {
            for (var xx = 0; xx < w; xx++) {
              var p = yy * w + xx, i = p * 4;
              var L = (0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2]) / 255;
              L = Math.min(1, Math.max(0, (L - 0.16) / 0.74)); L = Math.pow(L, 1.6);
              var ex = (xx - cx) / cx, ey = (yy - cy) / cy;
              var edge = round ? Math.max(0, 1 - Math.pow(Math.sqrt(ex * ex + ey * ey) / 1.05, 5))
                               : Math.max(0, 1 - Math.pow(Math.max(Math.abs(ex), Math.abs(ey)), 6));
              px[i] = 236; px[i + 1] = 246; px[i + 2] = 255;
              px[i + 3] = Math.round(255 * L * noise[p] * edge * 0.95);
            }
          }
          o.putImageData(data, 0, 0);
          return engCanvas;
        }
        // Custom text engraved into the preview
        var textEl = root.querySelector('[data-text-input]');
        function textInfo() {
          if (!textEl) return null;
          var t = textEl.value.trim();
          if (!t) return null;
          var c = root.querySelector('[data-text-pos]:checked');
          return { text: t, pos: c ? c.value : 'Bottom' };
        }
        function wrapLines(c, words, maxW) {
          var lines = [], line = '';
          words.forEach(function (wd) {
            var test = line ? line + ' ' + wd : wd;
            if (c.measureText(test).width <= maxW || !line) line = test; else { lines.push(line); line = wd; }
          });
          if (line) lines.push(line);
          return lines;
        }
        function drawText(c, info, kind, x, y, w, h, band) {
          // Usable width and centre of the text band for each shape
          var widthF = .84, centre;
          if (kind === 'heart' || kind === 'gemheart') {
            widthF = info.pos === 'Top' ? .62 : .46;
            centre = info.pos === 'Top' ? y + h * .27 : y + h * .7;
          } else if (kind === 'circle' || kind === 'octagon' || kind === 'diamond') {
            widthF = info.pos === 'Top' ? (kind === 'diamond' ? .72 : .6) : (kind === 'diamond' ? .34 : .6);
            centre = info.pos === 'Top' ? y + h * .17 : y + h * (kind === 'diamond' ? .66 : .83);
          } else {
            centre = info.pos === 'Top' ? y + h * .07 + band * .55 : y + h * .93 - band * .55;
          }
          var maxW = w * widthF, words = info.text.split(/\s+/);
          var size = Math.max(10, band * .42), lines;
          for (var tries = 0; tries < 40; tries++) {
            c.font = 'italic 600 ' + size + 'px Georgia, "Times New Roman", serif';
            lines = wrapLines(c, words, maxW);
            var widest = Math.max.apply(null, lines.map(function (l) { return c.measureText(l).width; }));
            if (lines.length <= 2 && widest <= maxW && lines.length * size * 1.15 <= band * 1.05) break;
            size *= .92;
          }
          c.save();
          c.textAlign = 'center'; c.textBaseline = 'middle';
          c.fillStyle = 'rgba(240,248,255,.95)';
          c.shadowColor = 'rgba(200,235,255,.9)'; c.shadowBlur = size * .35;
          var lh = size * 1.15, top = centre - (lines.length - 1) * lh / 2;
          lines.forEach(function (l, i) { c.fillText(l, x + w / 2, top + i * lh); });
          c.shadowBlur = 0; c.globalAlpha = .55;
          lines.forEach(function (l, i) { c.fillText(l, x + w / 2, top + i * lh); });
          c.restore();
        }
        if (textEl) textEl.addEventListener('input', function () { if (mockup.photo) { schedule(); clearTimeout(textEl._t); textEl._t = setTimeout(ensureThumb, 400); } });
        root.querySelectorAll('[data-text-pos]').forEach(function (r) {
          r.addEventListener('change', function () { if (mockup.photo) { draw(mockup.photo); ensureThumb(); } });
        });

        var box = null; // last drawn crystal box, used for dragging
        function draw(img) {
          var W = canvas.width, H = canvas.height;
          ctx.save(); ctx.clearRect(0, 0, W, H);
          var bg = ctx.createRadialGradient(W * .5, H * .35, W * .05, W * .5, H * .45, W * .8);
          bg.addColorStop(0, '#2b7fe0'); bg.addColorStop(.55, '#155bb8'); bg.addColorStop(1, '#0a2a66');
          ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
          ctx.fillStyle = 'rgba(4,14,40,.85)';
          ctx.beginPath(); ctx.ellipse(W * .5, H * .86, W * .48, H * .1, 0, 0, Math.PI * 2); ctx.fill();
          ctx.strokeStyle = 'rgba(120,200,255,.9)'; ctx.lineWidth = W * .006; ctx.shadowColor = '#5ab8ff'; ctx.shadowBlur = W * .03;
          ctx.beginPath(); ctx.ellipse(W * .5, H * .86, W * .4, H * .07, 0, 0, Math.PI * 2); ctx.stroke();
          ctx.shadowBlur = 0;

          var L = layout(img);
          var w = W * L.w, h = H * L.h, x = (W - w) / 2, y = H * .83 - h;
          var dx = W * L.depth, dy = -H * L.depth * .78;
          ctx.save(); ctx.translate(dx, dy); tracePath(ctx, L.kind, x, y, w, h);
          ctx.fillStyle = 'rgba(160,210,255,.10)'; ctx.fill();
          ctx.strokeStyle = 'rgba(210,235,255,.35)'; ctx.lineWidth = W * .003; ctx.stroke(); ctx.restore();
          if (L.kind === 'rect') {
            ctx.strokeStyle = 'rgba(210,235,255,.35)'; ctx.lineWidth = W * .003;
            [[x + w, y], [x + w, y + h], [x, y]].forEach(function (p) { ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(p[0] + dx, p[1] + dy); ctx.stroke(); });
          }
          tracePath(ctx, L.kind, x, y, w, h);
          var glass = ctx.createLinearGradient(x, y, x + w, y + h);
          glass.addColorStop(0, 'rgba(190,225,255,.34)'); glass.addColorStop(.5, 'rgba(120,180,245,.16)'); glass.addColorStop(1, 'rgba(190,225,255,.28)');
          ctx.fillStyle = glass; ctx.fill();
          ctx.save(); tracePath(ctx, L.kind, x, y, w, h); ctx.clip();
          var ix = x + w * .07, iy = y + h * .07, iw = Math.max(8, Math.round(w * .86)), ih = Math.max(8, Math.round(h * .86));
          var tInfo = textInfo();
          var band = tInfo ? Math.round(h * (L.kind === 'heart' || L.kind === 'gemheart' ? .2 : .19)) : 0;
          if (tInfo) { ih = Math.max(8, ih - band); if (tInfo.pos === 'Top') iy += band; }
          var eng = engrave(img, iw, ih, L.kind);
          ctx.globalAlpha = .45; ctx.filter = 'blur(' + Math.round(W * .006) + 'px)'; ctx.drawImage(eng, ix, iy);
          ctx.filter = 'none'; ctx.globalAlpha = 1; ctx.drawImage(eng, ix, iy);
          var sheen = ctx.createLinearGradient(x, y, x + w * .6, y + h);
          sheen.addColorStop(0, 'rgba(255,255,255,.22)'); sheen.addColorStop(.35, 'rgba(255,255,255,0)');
          if (tInfo) drawText(ctx, tInfo, L.kind, x, y, w, h, band);
          ctx.fillStyle = sheen; ctx.fillRect(x, y, w, h); ctx.restore();
          tracePath(ctx, L.kind, x, y, w, h);
          ctx.shadowColor = 'rgba(255,255,255,.8)'; ctx.shadowBlur = W * .012;
          ctx.strokeStyle = 'rgba(240,250,255,.85)'; ctx.lineWidth = W * .004; ctx.stroke(); ctx.shadowBlur = 0;
          // Height marker beside the crystal
          if (L.dims) {
            var mx = Math.min(W - W * .05, x + w + dx + W * .05);
            ctx.strokeStyle = 'rgba(255,255,255,.7)'; ctx.lineWidth = W * .0025;
            ctx.beginPath(); ctx.moveTo(mx, y); ctx.lineTo(mx, y + h);
            ctx.moveTo(mx - W * .012, y); ctx.lineTo(mx + W * .012, y);
            ctx.moveTo(mx - W * .012, y + h); ctx.lineTo(mx + W * .012, y + h); ctx.stroke();
            ctx.save(); ctx.translate(mx + W * .028, y + h / 2); ctx.rotate(-Math.PI / 2);
            ctx.fillStyle = '#fff'; ctx.font = '700 ' + Math.round(W * .026) + 'px Inter, system-ui, sans-serif'; ctx.textAlign = 'center';
            ctx.fillText(L.dims.h + (L.dims.unit === 'in' ? '″' : ' ' + L.dims.unit), 0, 0); ctx.restore();
          }
          ctx.restore();
          box = { x: ix / W, y: iy / H, w: iw / W, h: ih / H };
          if (sizePill) {
            var label = sizeIndex > -1 ? selected()[sizeIndex] : '';
            sizePill.textContent = L.dims ? (label ? label + ' · ' : '') + L.dims.text : '';
            sizePill.hidden = !L.dims;
          }
        }
        var raf = 0;
        function schedule() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; if (mockup.photo) draw(mockup.photo); }); }
        function describeFrame() {
          if (!framingInput) return;
          var parts = ['Zoom ' + Math.round(frame.zoom * 100) + '%'];
          if (Math.abs(frame.px) > .02) parts.push('shifted ' + Math.round(Math.abs(frame.px) * 100) + '% ' + (frame.px > 0 ? 'right' : 'left'));
          if (Math.abs(frame.py) > .02) parts.push('shifted ' + Math.round(Math.abs(frame.py) * 100) + '% ' + (frame.py > 0 ? 'down' : 'up'));
          framingInput.value = parts.join(', ');
        }
        function ensureThumb() {
          if (!thumbBar) {
            thumbBar = document.createElement('div'); thumbBar.className = 'lx-thumbs';
            (controls || root.querySelector('[data-main-media]')).insertAdjacentElement('afterend', thumbBar);
          }
          if (!pThumb) {
            pThumb = document.createElement('button');
            pThumb.type = 'button'; pThumb.className = 'lx-thumb lx-thumb-preview';
            pThumb.setAttribute('aria-label', 'Show your crystal preview');
            pThumb.innerHTML = '<img alt="" width="78" height="78"><span>Preview</span>';
            pThumb.addEventListener('click', function () { mockup.show(); });
            thumbBar.insertBefore(pThumb, thumbBar.firstChild);
          }
          pThumb.querySelector('img').src = canvas.toDataURL('image/jpeg', .7);
        }

        // Dragging the photo inside the crystal
        var drag = null;
        canvas.addEventListener('pointerdown', function (e) {
          if (!mockup.photo || !box) return;
          var r = canvas.getBoundingClientRect();
          var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          if (fx < box.x - .05 || fx > box.x + box.w + .05 || fy < box.y - .05 || fy > box.y + box.h + .05) return;
          drag = { x: e.clientX, y: e.clientY, px: frame.px, py: frame.py, rw: r.width, rh: r.height };
          canvas.setPointerCapture(e.pointerId); canvas.classList.add('is-dragging'); e.preventDefault();
        });
        canvas.addEventListener('pointermove', function (e) {
          if (!drag) return;
          var img = mockup.photo, bwpx = box.w * drag.rw, bhpx = box.h * drag.rh;
          var s = Math.max(bwpx / img.width, bhpx / img.height) * frame.zoom;
          var freeX = Math.max(1, img.width * s - bwpx), freeY = Math.max(1, img.height * s - bhpx);
          frame.px = Math.max(-1, Math.min(1, drag.px + 2 * (e.clientX - drag.x) / freeX));
          frame.py = Math.max(-1, Math.min(1, drag.py + 2 * (e.clientY - drag.y) / freeY));
          schedule();
        });
        function endDrag() { if (!drag) return; drag = null; canvas.classList.remove('is-dragging'); describeFrame(); ensureThumb(); }
        canvas.addEventListener('pointerup', endDrag);
        canvas.addEventListener('pointercancel', endDrag);
        if (zoomInput) zoomInput.addEventListener('input', function () { frame.zoom = parseFloat(zoomInput.value) / 100; schedule(); });
        if (zoomInput) zoomInput.addEventListener('change', function () { describeFrame(); ensureThumb(); });
        if (resetBtn) resetBtn.addEventListener('click', function () {
          frame = { zoom: 1, px: 0, py: 0 }; if (zoomInput) zoomInput.value = 100;
          if (mockup.photo) { draw(mockup.photo); describeFrame(); ensureThumb(); }
        });

        mockup = {
          photo: null,
          load: function (file) {
            var self = this, img = new Image();
            img.onload = function () {
              self.photo = img; msg.hidden = true;
              frame = { zoom: 1, px: 0, py: 0 }; if (zoomInput) zoomInput.value = 100;
              if (framingInput) framingInput.disabled = false;
              self.render(); describeFrame(); self.show(); if (seeBtn) seeBtn.hidden = false;
            };
            img.onerror = function () {
              self.photo = null; self.show(); if (controls) controls.hidden = true;
              if (framingInput) framingInput.disabled = true;
              ctx.fillStyle = '#0a2a66'; ctx.fillRect(0, 0, canvas.width, canvas.height);
              if (sizePill) sizePill.hidden = true;
              msg.textContent = 'We can’t preview this photo type in your browser, but it’s attached and we’ll use it for your crystal.';
              msg.hidden = false; if (seeBtn) seeBtn.hidden = true;
            };
            img.src = URL.createObjectURL(file);
          },
          render: function () { if (this.photo) { draw(this.photo); ensureThumb(); } },
          show: function () {
            mockEl.hidden = false; if (controls) controls.hidden = !this.photo;
            thumbs.forEach(function (x) { x.classList.remove('is-active'); });
            if (pThumb) pThumb.classList.add('is-active');
          },
          hide: function () { mockEl.hidden = true; if (controls) controls.hidden = true; if (pThumb) pThumb.classList.remove('is-active'); },
          clear: function () {
            this.photo = null; this.hide(); msg.hidden = true;
            if (pThumb) { pThumb.remove(); pThumb = null; }
            if (seeBtn) seeBtn.hidden = true;
            if (framingInput) { framingInput.value = ''; framingInput.disabled = true; }
          }
        };
        if (seeBtn) seeBtn.addEventListener('click', function () {
          mockup.show(); root.querySelector('[data-main-media]').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });

        // Attach the framed preview image to the order (where the browser allows it)
        var pform = root.querySelector('form');
        if (pform && previewFile) {
          pform.addEventListener('submit', function (e) {
            if (!mockup.photo || pform.dataset.previewAttached === 'true' || typeof DataTransfer === 'undefined') return;
            e.preventDefault(); e.stopImmediatePropagation();
            var submitter = e.submitter;
            canvas.toBlob(function (blob) {
              try {
                var dt = new DataTransfer();
                dt.items.add(new File([blob], 'crystal-preview.jpg', { type: 'image/jpeg' }));
                previewFile.files = dt.files; previewFile.disabled = false;
              } catch (err) {}
              pform.dataset.previewAttached = 'true';
              if (pform.requestSubmit) pform.requestSubmit(submitter && submitter.form === pform ? submitter : undefined); else pform.submit();
            }, 'image/jpeg', .85);
          }, true);
        }
      }

      // ---- Photo uploads: preview, file name and size check ----
      var MAX_MB = 20;
      root.querySelectorAll('[data-upload]').forEach(function (box) {
        var input = box.querySelector('[data-upload-input]');
        var drop = box.querySelector('[data-drop]');
        var preview = box.querySelector('[data-preview]');
        var icon = box.querySelector('[data-drop-icon]');
        var sub = box.querySelector('[data-drop-sub]');
        var action = box.querySelector('[data-drop-action]');
        var helpText = sub.textContent;
        function show() {
          var f = input.files && input.files[0];
          box.classList.remove('has-error');
          if (!f) {
            box.classList.remove('has-file'); preview.hidden = true; icon.hidden = false;
            sub.textContent = helpText; action.textContent = 'Choose';
            if (mockup && input.hasAttribute('data-mockup-source')) mockup.clear();
            return;
          }
          if (f.size > MAX_MB * 1024 * 1024) {
            input.value = ''; box.classList.add('has-error'); box.classList.remove('has-file');
            preview.hidden = true; icon.hidden = false;
            sub.textContent = 'That file is over ' + MAX_MB + ' MB. Please choose a smaller photo.';
            action.textContent = 'Choose'; return;
          }
          box.classList.add('has-file'); sub.textContent = f.name; action.textContent = 'Change';
          if (/^image\/(jpeg|png|webp|gif)$/.test(f.type)) {
            preview.src = URL.createObjectURL(f); preview.hidden = false; icon.hidden = true;
          } else { preview.hidden = true; icon.hidden = false; }
          if (mockup && input.hasAttribute('data-mockup-source')) mockup.load(f);
        }
        input.addEventListener('change', show);
        ['dragenter', 'dragover'].forEach(function (ev) {
          drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-dragover'); });
        });
        ['dragleave', 'drop'].forEach(function (ev) {
          drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-dragover'); });
        });
        drop.addEventListener('drop', function (e) {
          if (e.dataTransfer && e.dataTransfer.files.length) {
            try { input.files = e.dataTransfer.files; } catch (err) {}
            show();
          }
        });
      });

      // ---- Custom text: live character count ----
      var text = root.querySelector('[data-text-input]');
      var count = root.querySelector('[data-text-count]');
      if (text && count) {
        text.addEventListener('input', function () { count.textContent = text.value.length; });
      }
      var posValue = root.querySelector('[data-text-pos-value]');
      function syncPos() {
        if (!posValue || !text) return;
        var c = root.querySelector('[data-text-pos]:checked');
        posValue.value = c ? c.value : 'Bottom';
        posValue.disabled = !text.value.trim(); // only saved when there is text
      }
      if (text) text.addEventListener('input', syncPos);
      root.querySelectorAll('[data-text-pos]').forEach(function (r) { r.addEventListener('change', syncPos); });
      syncPos();

      // Disable the button while photos upload so customers don't double-submit
      var form = root.querySelector('form');
      // File uploads need multipart encoding
      if (form && form.querySelector('[data-upload-input]')) form.setAttribute('enctype', 'multipart/form-data');
      if (form && addBtn) {
        form.addEventListener('submit', function () {
          if (form.querySelector('[data-upload-input]')) {
            setTimeout(function () { addBtn.disabled = true; addBtn.textContent = 'Uploading…'; }, 0);
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
